import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { customContainer } from '@utils/twin-macro';

import Text from '@components/text';

const Border = styled.div`
  max-width: 915px;
  ${tw`mx-auto mb-12 border-t border-greenBlog md:mb-50`}
`;

const Wrapper = styled.div`
  ${customContainer}
  ${tw`
    flex w-320 mb-30 px-10
    md:w-535 md:mb-32
    lg:px-0
  `}
`;

const Placeholder = styled.div`
  width: 95px;
  min-width: 95px;
  height: 95px;
  min-height: 95px;
  ${tw`mr-20 rounded-full overflow-hidden md:mr-30`}
`;

const Name = tw(Text)`md:mt-5`;

const Author = ({ author, locale }) => (
  <>
    <Border />
    <Wrapper>
      <Placeholder>
        <Img fluid={author.img.asset.fluid} />
      </Placeholder>
      <div>
        <Name color="redBlog" fontSizes={18} fontWeight={600} lineHeight={1.4} letterSpacing={22}>
          {author.name}
        </Name>
        <Text color="redBlog" fontSizes={18} lineHeight={1.4} letterSpacing={22}>
          {author.position}
        </Text>
        <Text fontSizes={18} fontWeight={300} lineHeight={1.4} letterSpacing={22}>
          {author[`desc_${locale}`]}
        </Text>
      </div>
    </Wrapper>
  </>
);

Author.propTypes = {
  author: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(
        PropTypes.objectOf(
          PropTypes.objectOf(
            PropTypes.oneOfType([
              PropTypes.string,
              PropTypes.number,
            ]),
          ),
        ),
      ),
    ]),
  ).isRequired,
  locale: PropTypes.string.isRequired,
};

export default Author;
